var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        id: "promo-zero-modal",
        "no-close-on-backdrop": "",
        "no-close-on-esc": "",
        "hide-header": "",
        "hide-header-close": "",
        "hide-footer": ""
      }
    },
    [
      _c("p", { staticClass: "my-4" }, [_vm._t("default")], 2),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-outline-secondary rg-border-radius mx-auto",
            attrs: { size: "sm" },
            on: { click: _vm.clickAcknowledge }
          },
          [_vm._v("\n      " + _vm._s(_vm.acknowledge) + "\n    ")]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }